// src/redux/authSlice.js
import { createSlice } from '@reduxjs/toolkit'

// Intenta cargar desde localStorage al iniciar
const tokenFromStorage = localStorage.getItem('token')
let userFromStorage = null

try {
  const userData = localStorage.getItem('user')
  userFromStorage = userData && userData !== 'undefined' ? JSON.parse(userData) : null
} catch (e) {
  console.error('Error al parsear usuario desde localStorage', e)
  localStorage.removeItem('user') // opcional, por seguridad
}



const initialState = {
  token: tokenFromStorage || null,
  user: userFromStorage || null,
  isAuthenticated: !!tokenFromStorage,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token
      state.user = action.payload.user
      state.isAuthenticated = true

      // Persistimos
      localStorage.setItem('token', action.payload.token)
      localStorage.setItem('user', JSON.stringify(action.payload.user))
    },
    logout: (state) => {
      state.token = null
      state.user = null
      state.isAuthenticated = false

      // Borramos del storage
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
  },
})

export const { loginSuccess, logout } = authSlice.actions
export default authSlice.reducer
